import gql from 'graphql-tag';

const UPDATE_LIST = gql`
  mutation UpdateList($input: UpdateListInput) {
    updateList(input: $input) {
      list {
        name
      }
    }
  }
`;

export default UPDATE_LIST;
